export * from './ScanAtCheckoutFooterText';
